import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/logo.png'
import _imports_1 from '@/assets/menu.svg'


const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "container navbar-container" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = {
  key: 0,
  src: _imports_1,
  alt: "菜单"
}
const _hoisted_5 = {
  key: 1,
  class: "el-icon-close"
}
const _hoisted_6 = { class: "nav-links" }
const _hoisted_7 = { class: "user-area" }
const _hoisted_8 = { class: "user-avatar" }
const _hoisted_9 = ["src"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")
  const _component_el_button = _resolveComponent("el-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "股票资讯AI智能分析"
            }, null, -1),
            _createElementVNode("div", { class: "logo-divider" }, null, -1),
            _createElementVNode("span", { class: "logo-text" }, "股票资讯AI智能分析", -1)
          ]))]),
          _: 1
        })
      ]),
      _createElementVNode("div", {
        class: "menu-toggle",
        onClick: _cache[0] || (_cache[0] = (...args) => ($setup.toggleMobileMenu && $setup.toggleMobileMenu(...args)))
      }, [
        (!$setup.mobileMenuOpen)
          ? (_openBlock(), _createElementBlock("img", _hoisted_4))
          : (_openBlock(), _createElementBlock("i", _hoisted_5))
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["mobile-menu", { 'open': $setup.mobileMenuOpen }])
      }, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "menu-item",
          onClick: $setup.closeMobileMenu
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode("首页", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_router_link, {
          to: "/search",
          class: "menu-item",
          onClick: $setup.closeMobileMenu
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode("搜索股票", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_router_link, {
          to: "/forecast",
          class: "menu-item",
          onClick: $setup.closeMobileMenu
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode("业绩预测", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"]),
        ($setup.isLoggedIn)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: "/favorites",
              class: "menu-item",
              onClick: $setup.closeMobileMenu
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("我的自选股", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        ($setup.isLoggedIn)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_router_link, {
                to: "/profile",
                class: "menu-item",
                onClick: $setup.closeMobileMenu
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("个人信息", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createElementVNode("div", {
                class: "menu-item",
                onClick: _cache[1] || (_cache[1] = (...args) => ($setup.handleLogout && $setup.handleLogout(...args)))
              }, "退出登录")
            ], 64))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: 2,
              to: "/login",
              class: "menu-item",
              onClick: $setup.closeMobileMenu
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode("登录", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"]))
      ], 2),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "nav-item",
          onClick: $setup.closeMobileMenu
        }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
            _createTextVNode("首页", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_router_link, {
          to: "/search",
          class: "nav-item",
          onClick: $setup.closeMobileMenu
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createTextVNode("搜索股票", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_router_link, {
          to: "/forecast",
          class: "nav-item",
          onClick: $setup.closeMobileMenu
        }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
            _createTextVNode("业绩预测", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"]),
        ($setup.isLoggedIn)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: "/favorites",
              class: "nav-item",
              onClick: $setup.closeMobileMenu
            }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                _createTextVNode("我的自选股", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        ($setup.isLoggedIn)
          ? (_openBlock(), _createBlock(_component_el_dropdown, {
              key: 0,
              trigger: "click"
            }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: "/profile",
                          onClick: $setup.closeMobileMenu
                        }, {
                          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                            _createTextVNode("个人信息", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, { onClick: $setup.handleLogout }, {
                      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                        _createTextVNode("退出登录", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("img", {
                    src: $setup.currentUser?.avatar || $setup.defaultAvatar,
                    alt: "头像"
                  }, null, 8, _hoisted_9),
                  _createElementVNode("span", null, _toDisplayString($setup.currentUser?.name || '用户'), 1),
                  _cache[13] || (_cache[13] = _createElementVNode("i", { class: "el-icon-arrow-down" }, null, -1))
                ])
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: "/login",
              class: "login-btn",
              onClick: $setup.closeMobileMenu
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "small"
                }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode("登录", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"]))
      ])
    ])
  ]))
}